import { CalendarFilterOutlineIcon } from './CalendarFilterOutlineIcon';

/**
 * author: Andrej Sharapov
 * id 0EE2D0EE-8A23-4A80-98AC-0AEE15333062
 * name calendar-filter-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-filter-outline.svg
 * tags
 * - Date / Time 
 */
export const EventWeekEndOutlineIcon = CalendarFilterOutlineIcon;
export default EventWeekEndOutlineIcon